<template>
    <div :class="[data.progress == 'failed' ? 'bg-red-300' : 'bg-orange-500']"
        class="downlaod flex items-center w-full max-w-xs p-4 space-x-4 text-gray-500 divide-x rtl:divide-x-reverse divide-gray-200 rounded-lg shadow right-5 bottom-5 dark:text-gray-400 dark:divide-gray-700 space-x dark:bg-gray-800"
         role="alert">
        <div class="flex items-center w-full text-white">
            <div class="text-sm font-normal">
                <span class="text-[10px]">{{ data.msg }} for {{ data.name }}</span>
            </div>
                
            <button @click="$emit('closeToast')" type="button" class="ms-5 -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700" aria-label="Close">
                <i class="fa-solid fa-xmark h-6 w-6"></i>
            </button>
        </div>
    </div>
</template>

<script setup>
defineProps(['data'])
const emit = defineEmits(['closeToast'])

setTimeout(() => {
    emit('closeToast')
}, 5000);
</script>

<style scoped>
.downlaod {
    z-index: 999;
}
</style>